import type { PageNotification } from '../../hooks/usePageNotifications';

function toneClass(tone: PageNotification['tone']): string {
  if (tone === 'ok') return 'dem-page-toast--ok';
  if (tone === 'warn') return 'dem-page-toast--warn';
  if (tone === 'error') return 'dem-page-toast--error';
  if (tone === 'neutral') return 'dem-page-toast--neutral';
  return 'dem-page-toast--info';
}

type PageNotificationToastProps = {
  notification: PageNotification;
  onDismiss: () => void;
  onOpen?: () => void;
};

export function PageNotificationToast({ notification, onDismiss, onOpen }: PageNotificationToastProps) {
  return (
    <div
      className={`dem-page-toast ${toneClass(notification.tone)}${onOpen ? ' dem-page-toast--clickable' : ''}`}
      role={notification.tone === 'error' || notification.tone === 'warn' ? 'alert' : 'status'}
      aria-live={notification.tone === 'error' || notification.tone === 'warn' ? 'assertive' : 'polite'}
      onClick={onOpen}
    >
      <div className="dem-page-toast__body">
        <p className="dem-page-toast__title">{notification.title}</p>
        {notification.lines.map((line) => (
          <p key={line} className="dem-page-toast__line">
            {line}
          </p>
        ))}
      </div>
      <button
        type="button"
        className="dem-page-toast__close"
        aria-label="Dismiss notification"
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
        }}
      >
        ×
      </button>
    </div>
  );
}
